module.exports = __webpack_public_path__ + "img/chevron-left.d2cccb.svg";